export default class LoginForm {
  userName: string = ''
  password: string = ''
  rememberPassword: boolean = false
}
